import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';
import { Mail, ArrowRight, ArrowLeft, CheckCircle2 } from 'lucide-react';
import { Button, Input } from '../components/ui';

const ForgotPassword = () => {
  const [email, setEmail] = useState('');
  const [submitting, setSubmitting] = useState(false);
  const [sent, setSent] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSubmitting(true);
    try {
      // Backend always returns success regardless of whether the email
      // exists (anti-enumeration) — so this UI has nothing to branch on
      // except "the request went through."
      await axios.post('/api/auth/forgot-password', { email });
    } catch (_) {
      // Even a network error shouldn't reveal anything different — show the
      // same confirmation state either way.
    } finally {
      setSubmitting(false);
      setSent(true);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-b from-neutral-50 to-neutral-100 p-6">
      <div className="w-full max-w-md">
        <div className="bg-white border border-neutral-200/70 rounded-2xl shadow-[0_18px_50px_-20px_rgba(15,23,42,0.28)] p-8 sm:p-9">
          {sent ? (
            <div className="text-center">
              <div className="w-12 h-12 rounded-xl bg-success-50 text-success-600 flex items-center justify-center mb-4 ring-1 ring-success-100 mx-auto">
                <CheckCircle2 size={22} />
              </div>
              <h2 className="text-xl font-bold text-neutral-900 tracking-tight">Check your email</h2>
              <p className="text-sm text-neutral-500 mt-2">
                If an account exists for <span className="font-medium text-neutral-700">{email}</span>, we've sent a password reset link.
              </p>
            </div>
          ) : (
            <>
              <div className="mb-7">
                <div className="w-12 h-12 rounded-xl bg-primary-50 text-primary-600 flex items-center justify-center mb-4 ring-1 ring-primary-100">
                  <Mail size={20} />
                </div>
                <h2 className="text-2xl font-bold text-neutral-900 tracking-tight">Reset your password</h2>
                <p className="text-sm text-neutral-500 mt-1.5">Enter your email and we'll send you a reset link.</p>
              </div>
              <form onSubmit={handleSubmit} className="space-y-5">
                <Input
                  label="Email address"
                  type="email"
                  leftIcon={<Mail size={16} />}
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  placeholder="you@restaurant.com"
                  autoComplete="email"
                  required
                />
                <Button
                  type="submit"
                  variant="primary"
                  size="lg"
                  fullWidth
                  loading={submitting}
                  rightIcon={!submitting && <ArrowRight size={18} />}
                >
                  {submitting ? 'Sending…' : 'Send reset link'}
                </Button>
              </form>
            </>
          )}
        </div>

        <p className="text-sm text-neutral-500 text-center mt-6 flex items-center justify-center gap-1">
          <ArrowLeft size={14} />
          <Link to="/login" className="text-primary-600 font-medium hover:text-primary-700">Back to sign in</Link>
        </p>
      </div>
    </div>
  );
};

export default ForgotPassword;
